import "./ArticleCard.scss";

import React from "react";

import {
  Button,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography
} from "@mui/material";

import { ArticleCardData } from "../../models/app-data-model";
import { getContentHubDamAsset } from "../../utils/get-contenthub-dam-asset";

export type ArticleCardProps = {
  articleCardData: ArticleCardData;
  variant:string;
};

const ArticleCard: React.FC<ArticleCardProps> = ({ articleCardData, variant }) => {
  const button_label = articleCardData?.button_label;
  const title = articleCardData?.title;
  const url = (articleCardData?.reference[0]?.url || (getContentHubDamAsset(articleCardData?.reference[0]?.contenthub_asset)?.url));
  const nav_title = articleCardData?.reference[0]?.seo?.nav_title;
  const description = articleCardData?.reference[0]?.seo?.description;
  const contenthubDamAsset = (articleCardData.reference[0]?.seo && articleCardData.reference[0]?.seo.contenthub_asset && getContentHubDamAsset(articleCardData.reference[0]?.seo.contenthub_asset));
  const image_url = contenthubDamAsset && contenthubDamAsset?.url || "https://priorityhealth.stylelabs.cloud/api/public/content/b6508155067f44ef9397ae1f42475021" ; 
  const image_title = contenthubDamAsset && contenthubDamAsset?.title;
  const image_alt = contenthubDamAsset && contenthubDamAsset?.alt_text || contenthubDamAsset?.title;

  return (
    <Card className={`article-card ${variant}`}>
      <CardActionArea title={title} href={`${url}`}>
        <CardMedia className="article-image" component="img" image={image_url} title={image_title} alt={image_alt} />
        <CardContent>
          <Typography variant="body2">
            {description}
          </Typography>
        </CardContent>
        <CardActions>
          <Button className="action-button" size="medium" variant="contained" title={nav_title}>{button_label}</Button>
        </CardActions>
      </CardActionArea>
    </Card>
  );
};

export default ArticleCard;
